import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useModalElementContext from './useModalElementContext'
import useDidChange from 'hooks/useDidChange'

function useModalCloseOnLocationChange() {
  const location = useLocation()
  const modalElementContext = useModalElementContext()
  const locationChanged = useDidChange(location, location)
  const isModalOpen = modalElementContext?.open

  useEffect(() => {
    if (isModalOpen && locationChanged) {
      modalElementContext?.resolve(undefined)
    }
  }, [isModalOpen, locationChanged, modalElementContext])
}

export default useModalCloseOnLocationChange
